/**
 * _BookingForm.js
 */

//  Homepage

import $ from 'jquery';
import Utilities from './Utilities';
// import Pikaday from 'pikaday';
// var moment = require('moment');

import flatpickr from "flatpickr";
import moment from 'moment';

class BookingForm {

    constructor() {

        var checkIn = flatpickr('#check-in', {
            minDate: "today",
            dateFormat: "m/d/Y",
            defaultDate: 'today',
            nextArrow: '<i class="icon-arrow-right"></i>',
            prevArrow: '<i class="icon-arrow-left"></i>',
        });

        var checkOut = flatpickr('#check-out', {
            minDate: "today",
            dateFormat: "m/d/Y",
            defaultDate: moment().add(1, 'days').format('L'),
            nextArrow: '<i class="icon-arrow-right"></i>',
            prevArrow: '<i class="icon-arrow-left"></i>',
        });

        $('.flatpickr-day', checkIn.daysContainer).on('keydown', function (e) {
            if (e.keyCode === 9) {
                checkIn.element.focus()
            }
        });

        $('.flatpickr-day', checkOut.daysContainer).on('keydown', function (e) {
            if (e.keyCode === 9) {
                checkOut.element.focus()
            }
        });

        // Venue detail forms.
        $(document).bind('gform_post_render', function () {

            // destroy default Gravity Form datepicker
            $('#input_1_6, #input_2_1').datepicker('destroy');
            $('#input_1_6, #input_2_1').removeClass("hasDatepicker")
            $('#input_1_6, #input_2_1').removeClass('calendarclass');

            flatpickr('#input_1_6, #input_2_1', {
                minDate: "today",
                dateFormat: "m/d/Y",
                defaultDate: 'today',
                nextArrow: '<i class="icon-arrow-right"></i>',
                prevArrow: '<i class="icon-arrow-left"></i>',
            })

        });
    }

}
new BookingForm();
